(() => {
  if (!window.BroadcastChannel) return;
  const source = document.getElementById("plug-customer-session");
  if (!source) return;
  const customer = String(JSON.parse(source.textContent));
  const RELOAD_KEY = "plug-customer-session-reload-v1";
  // Only the rebroadcast right after a reload is suppressed; a later real logout must still reload.
  const RELOAD_WINDOW_MS = 10000;
  function pendingReload() {
    try {
      const value = window.sessionStorage?.getItem(RELOAD_KEY);
      if (!value) return null;
      const pending = JSON.parse(value);
      return typeof pending?.from === "string" && typeof pending?.to === "string" ? pending : null;
    } catch {
      return null;
    }
  }
  function clearCompletedReload() {
    try {
      if (pendingReload()?.to === customer) window.sessionStorage.removeItem(RELOAD_KEY);
    } catch {}
  }
  function markReload(nextCustomer) {
    const pending = pendingReload();
    if (
      pending?.from === customer &&
      pending.to === nextCustomer &&
      Date.now() - pending.at < RELOAD_WINDOW_MS
    )
      return false;
    try {
      window.sessionStorage?.setItem(
        RELOAD_KEY,
        JSON.stringify({ from: customer, to: nextCustomer, at: Date.now() })
      );
    } catch {}
    return true;
  }
  clearCompletedReload();
  const channel = new BroadcastChannel("plug-customer-session");
  channel.onmessage = ({ data }) => {
    if (
      data?.type !== "session-observed" ||
      typeof data.customer !== "string" ||
      data.customer === customer ||
      !document.querySelector("[data-for-you-overview]")
    )
      return;
    if (!markReload(data.customer)) return;
    channel.close();
    // Remove all old private DOM before a new authenticated page can paint.
    document.querySelector("main")?.replaceChildren();
    window.location.reload();
  };
  channel.postMessage({ type: "session-observed", customer });
})();
